import { render, staticRenderFns } from "./ClubInformation.vue?vue&type=template&id=3ca65bb2&scoped=true"
import script from "./ClubInformation.vue?vue&type=script&lang=js"
export * from "./ClubInformation.vue?vue&type=script&lang=js"
import style0 from "./ClubInformation.vue?vue&type=style&index=0&id=3ca65bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca65bb2",
  null
  
)

export default component.exports